<template>
<div>
  <van-field
      v-model="result"
      is-link
      readonly
      name="picker"
      input-align='right'
      :label="label"
      :placeholder="placeholder"
      @click="showPicker = true"
  />
  <van-popup v-model:show="showPicker" position="bottom">
    <van-picker
        :columns="options"
        @confirm="onConfirm"
        :columns-field-names="columnsFieldNames"
        @cancel="showPicker = false"
    />
  </van-popup>
</div>
</template>

<script>
export default {
  name: "Select",
  props:{
    modelValue: Object,
    label:String,
    placeholder:String,
    options:Array,
    optionName:String,
    optionValue:String,
  },
  emits: ['update:modelValue'],
  data(){
    return{
      result: '',
      columnsFieldNames:{
        text:"label",
        value:"value",
      },
      showPicker:false,
    }
  },

  mounted(){
    if(this.optionName!=null){
      this.columnsFieldNames.text=this.optionName
    }
    if(this.optionValue!=null){
      this.columnsFieldNames.value=this.optionValue
    }
    if(this.options!=null){
      var d={}
      d[this.columnsFieldNames.text]="无"
      this.options.push(d)
    }
    if(this.modelValue!=null){
      for(var key in this.options){
        if(this.options[key][this.columnsFieldNames.value]==this.modelValue){
          this.result=this.options[key][this.columnsFieldNames.text]
        }
      }
    }

  },
  watch:{
    modelValue:function () {
      if(this.modelValue!=null){
        for(var key in this.options){
          if(this.options[key][this.columnsFieldNames.value]==this.modelValue){
            this.result=this.options[key][this.columnsFieldNames.text]
          }
        }
      }
    }
  },
  methods:{

    onConfirm(item){
      this.result = item[this.columnsFieldNames.text];

      this.$emit('update:modelValue',item[this.columnsFieldNames.value])
      this.showPicker = false;
    }
  }

}
</script>

<style scoped>

</style>
